import { Box, Popover, Typography } from '@material-ui/core';
import { CSSProperties, MouseEvent, useEffect, useState } from 'react';
import { WbTextField } from '../WbTextField';
import { FiltersButton } from './FilterButtons';
import { FilterInput } from './FilterInput';
import { NumberTableFilter } from './types';

const NumberFilterValue = ({ field, value }: NumberTableFilter) => {
  const ellipsis: CSSProperties = {
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  };

  return (
    <Typography style={ellipsis}>
      {field}
      {value && (
        <>
          <Typography component="span">:</Typography>
          <Typography
            style={{ fontWeight: '600', marginLeft: '5px' }}
            component="span"
          >
            {value}
          </Typography>
        </>
      )}
    </Typography>
  );
};

export const NumberFilter = (filter: NumberTableFilter) => {
  const [value, setValue] = useState(filter.value);
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const handleClick = (event: MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
    setTimeout(() => setValue(filter.value), 500);
  };

  useEffect(() => {
    setValue(filter.value);
  }, [filter.value]);

  return (
    <Box>
      <FilterInput
        onClick={handleClick}
        onClear={() => {
          filter.onChange(undefined);
          setValue(undefined);
        }}
        isOpened={open}
        selected={Boolean(filter.value)}
        maxWidth="300px"
        hideClear={filter.hideClear}
      >
        <NumberFilterValue {...filter} />
      </FilterInput>

      <Popover
        disableRestoreFocus
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box style={{ width: '280px', background: 'white' }}>
          <Box style={{ margin: '8px' }}>
            <WbTextField
              variant="outlined"
              ariaLabel="Start typing to filter"
              type="number"
              placeholder={
                filter.placeholder
                  ? filter.placeholder
                  : 'Start typing to filter'
              }
              InputLabelProps={{ shrink: true }}
              onChange={e => setValue(Number(e.target.value))}
              value={value}
              inputProps={{ style: { height: '64px' } }}
            />
          </Box>

          <FiltersButton
            cancel={{
              onClick: handleClose,
            }}
            apply={{
              onClick: () => {
                filter.onChange(value);
                setAnchorEl(null);
              },
            }}
          />
        </Box>
      </Popover>
    </Box>
  );
};
